'use client';

import {
  createContext,
  useState,
  useContext,
  type Dispatch,
  type SetStateAction
} from 'react';

type Options = {
  articleName: string;
  slug: string;
  contentType: TUDContentType;
  topAds?: React.ReactNode | null;
  alwaysFixed: boolean;
  sideAds: boolean;
  bottomAds?: React.ReactNode | null;
  showAds: boolean;
};

const defaultOptions: Options = {
  articleName: '',
  contentType: 'article',
  slug: '',
  topAds: null,
  alwaysFixed: false,
  sideAds: true,
  bottomAds: null,
  showAds: true
};

export const OptionsContext = createContext<Options>(defaultOptions);

export const OptionsDispatchContext = createContext<Dispatch<
  SetStateAction<Options>
> | null>(null);

export default function OptionsProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [options, setOptions] = useState<Options>(defaultOptions);

  return (
    <OptionsContext.Provider value={options}>
      <OptionsDispatchContext.Provider value={setOptions}>
        {children}
      </OptionsDispatchContext.Provider>
    </OptionsContext.Provider>
  );
}

export function useOptions() {
  return useContext(OptionsContext);
}

export function useOptionsDispatch() {
  return useContext(OptionsDispatchContext);
}
